import { Validators } from '@angular/forms';
import { INPUT_TYPES_CONFIG } from '../products.config';

export const ACCIDENT = {
  nickname: 'PRODUCTS.ACCIDENT.shortname',
  properties: [
    {
      name: 'accidentType', key: 'ACCIDENT_TYPE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.ACCIDENT_TYPE.NON_MANUAL_WORK', value: 'NON_MANUAL_WORK' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.ACCIDENT_TYPE.MANUAL_LAND_WORK', value: 'MANUAL_LAND_WORK' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.ACCIDENT_TYPE.SEAFARERS_FISHERS_OFFSHORE', value: 'SEAFARERS_FISHERS_OFFSHORE' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.ACCIDENT_TYPE.PUPIL_STUDENT', value: 'PUPIL_STUDENT' },
        ]
      }
    },
    {
      name: 'wtcAccidentCoverage', key: 'ACCIDENT_COVERAGE', group: 'INSURANCE_INFO',
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.ACCIDENT_COVERAGE.FULL_TIME', value: 'FULL_TIME' },
        ]
      }
    },
    {
      name: 'accidentSumInsuredDisability', key: 'ACCIDENT_SUM_INSURED_INCAPACITY', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.ACCIDENT_SUM_INSURED_INCAPACITY.500000', value: '500000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.ACCIDENT_SUM_INSURED_INCAPACITY.1000000', value: '1000000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.ACCIDENT_SUM_INSURED_INCAPACITY.2000000', value: '2000000' },
        ]
      }
    },
    {
      name: 'wtcAccidentProgressive', key: 'ACCIDENT_PROGRESSIVE', group: 'INSURANCE_INFO',
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.ACCIDENT_PROGRESSIVE.YES', value: 'YES' },
        ]
      }
    },
    {
      name: 'wtcAccidentName', key: 'ACCIDENT_NAME', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.STRING,
      validator: ['']
    },
    {
      name: 'wtcAccidentSumInsuredDeath', key: 'ACCIDENT_SUM_INSURED_DEATH', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.ACCIDENT_SUM_INSURED_DEATH.0', value: '0' },
        ]
      }
    },
  ],
  lifeInsurance: true,
  icon: 'accident'
};
